export const LINEAR_ABSOLUTE_START_URL_PARAM = "absStart"
export const LINEAR_ABSOLUTE_END_URL_PARAM = "absEnd"